export enum ActionEnum {
  SUSPENDED = 8,
  DELETE = 7,
  ACTIVATE = 3,
  DEACTIVATE = 17,
}
